import { render, staticRenderFns } from "./Human.vue?vue&type=template&id=397d29f0&"
import script from "./Human.vue?vue&type=script&lang=ts&"
export * from "./Human.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('397d29f0')) {
      api.createRecord('397d29f0', component.options)
    } else {
      api.reload('397d29f0', component.options)
    }
    module.hot.accept("./Human.vue?vue&type=template&id=397d29f0&", function () {
      api.rerender('397d29f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/History/Human.vue"
export default component.exports